import { CommonGet, CommonPost } from '../../helpers/HttpClient';

export default {
  getAllGroups,
  GetSupplierQuotationDetails,
  SavePurchaseOrderDetails,
  GeneratePurchaseOrderNumber,
  getQuotationsByRequisition,
  getRequisitionbySupplierID,
  getDeliveryInstructions,
  getTermsandConditions,
  getFactoryByGroupID,
  GetSuppliersByGroupIDAndFactoryID
}

async function getAllGroups() {
  let response = await CommonGet('/api/Factory/GetAllActiveGroups', null);
  let groupArray = []
  for (let item of Object.entries(response.data)) {
    groupArray[item[1]["groupID"]] = item[1]["groupName"]
  }
  return groupArray;
}

async function GetSuppliersByGroupIDAndFactoryID(groupID, factoryID) {
  var supplierArray = [];
  const response = await CommonGet('/api/PurchaseOrderNew/GetSuppliersByGroupforPO', "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));
  for (let item of Object.entries(response.data)) {
    supplierArray[item[1]["supplierID"]] = item[1]["supplierName"];
  }
  return supplierArray;
}

async function SavePurchaseOrderDetails(model) {
  const response = await CommonPost('/api/PurchaseOrderNew/SavePurchaseOrderDetails', null, model);
  return response;
};

async function GeneratePurchaseOrderNumber(groupID, factoryID) {
  let response = await CommonGet('/api/PurchaseOrderNew/GeneratePurchaseOrderNumber', "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));
  return response;
};

async function GetSupplierQuotationDetails(model) {
  const response = await CommonPost('/api/PurchaseOrderNew/GetSupplierQuotationDetails', null, model);
  return response;
};

async function getQuotationsByRequisition(requisitionIDList) {
  let response = await CommonGet('/api/PurchaseOrderNew/GetQuotationsByRequisition', "requsitionIDs=" + requisitionIDList);
  return response.data;
};

async function getRequisitionbySupplierID(factoryID, supplierID) {
  let response = await CommonGet('/api/PurchaseOrderNew/GetRequisitionbySupplierID', "factoryID=" + parseInt(factoryID) + "&supplierID=" + parseInt(supplierID));
  return response.data;
};

async function getTermsandConditions() {
  let response = await CommonGet('/api/PurchaseOrderNew/GetTermsandConditions', null);
  let groupArray = []
  for (let item of Object.entries(response.data)) {
    groupArray[item[1]["termsAndConditionsID"]] = item[1]["termsAndConditions"]
  }
  return groupArray;
}

async function getDeliveryInstructions() {
  let response = await CommonGet('/api/PurchaseOrderNew/GetDeliveryInstructions', null);
  let groupArray = []
  for (let item of Object.entries(response.data)) {
    groupArray[item[1]["deliveryInstructionsID"]] = item[1]["deliveryInstructions"]
  }
  return groupArray;
}

async function getFactoryByGroupID(groupID) {
  var factoryArray = [];

  const response = await CommonGet('/api/Group/GetFactoryByGroupID', 'groupID=' + groupID)
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
  }
  return factoryArray;
}
